import { NgModule } from '@angular/core';
import { EcallStatusNum2statusNameDirective } from './ecall-statusnum2statusname.directive';

@NgModule({
  imports: [

  ],
  declarations: [
    EcallStatusNum2statusNameDirective
  ],
  exports: [
    EcallStatusNum2statusNameDirective
  ]
})

export class EcallStatusNum2StatusNameModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/ecall-statusnum2statusname/ecall-statusnum2statusname.module.ts